import React from 'react';

import SMStream from '../streams/SMStream2';
import { connect } from 'react-redux';
import _ from 'lodash';
import { fetchEventsKey, fetchEvents } from 'dash-front/actions/events';
import { EventsList } from './views/EventsList';
import moment from 'moment';

const matchesList = (tournament, events, daysToTake = 1000) => {
    return (
        tournament &&
        _.chain(events)
            .groupBy(e => moment(e.startDate).format('YYYY-MM-DD'))
            .keys()
            .take(daysToTake)
            .map(date => {
                return {
                    name: 'TodayMatchesSMWidget',
                    groupTitle: `Matchday ${moment(date).format('D MMM')}`,
                    groupKey: `${date + '_' + tournament.id}`,
                    props: {
                        tournamentId: tournament.id,
                        date: date
                    },
                    key: `${date + '_' + tournament.id}`
                };
            })
            .value()
    );
};

const playoffWCStage = (tournament, season) => {
    return [
        {
            name: 'PlayoffGridSMWidget',
            groupKey: `playoff`,
            props: {
                tournamentId: tournament.id,
                seasonId: season.id,
                stageIds: JSON.stringify(_.filter(season.stages, s => s.isCup).map(s => s.id))
            },
            key: `tt-${season.id}-playoff`
        },
        {
            name: 'TournamentPlayOffSMWidget',
            props: {
                tournamentId: tournament.id,
                stageIds: JSON.stringify(_.filter(season.stages, s => s.isCup).map(s => s.id))
            }
        }
    ];
};

const playoffCLStage = (tournament, season) => {
    const qual = season.stages[0];
    return [
        qual && {
            name: 'PlayoffGridSMWidget',
            groupKey: `playoff`,
            props: {
                tournamentId: tournament.id,
                seasonId: season.id,
                stageIds: JSON.stringify([qual.id])
            },
            key: `tt-${season.id}-qual`
        },
        {
            name: 'PlayoffGridSMWidget',
            groupKey: `playoff-2`,
            props: {
                tournamentId: tournament.id,
                seasonId: season.id,
                stageIds: JSON.stringify(_.filter(season.stages, s => s.isCup && s.id !== qual.id).map(s => s.id))
            },
            key: `tt-${season.id}-playoff`
        }
    ];
};

const generalTournamentWidget = (tournament, season, withAnimated = false, withSVG = false) => {
    let widgets = tournament &&
        season && [
            ..._.filter(season.stages, s => !s.isCup).map(stage => ({
                name: 'TournamentTableSMWidget',
                groupKey: `${stage.enetPulseName}`,
                props: {
                    tournamentId: tournament.id,
                    seasonId: season.id,
                    stageId: stage.id,
                    full: true
                },
                key: `tt-${season.id}-${stage.id}`
            }))
        ];

    if (withAnimated) {
        widgets = widgets.concat(
            _.filter(season.stages, s => !s.isCup).map(stage => ({
                name: 'LeagueTrackerSMWidget',
                groupKey: `${stage.enetPulseName} League Tracker`,
                props: {
                    tournamentId: tournament.id,
                    seasonId: season.id,
                    stageId: stage.id,
                    lineSmoothing: true
                },
                key: `lt-${season.id}-${stage.id}`
            }))
        );
    }

    if (withSVG) {
        widgets = widgets.concat(
            _.filter(season.stages, s => !s.isCup).map(stage => ({
                name: 'AnimatedTournamentTable',
                groupKey: `${stage.enetPulseName} Animated `,
                props: {
                    tournamentId: tournament.id,
                    seasonId: season.id,
                    stageId: stage.id,
                    full: true
                },
                key: `tt-a-${season.id}-${stage.id}`
            }))
        );
    }

    return widgets;
};

const basicTopList = (tournament, season) =>
    tournament && [
        {
            name: 'TopListSMWidget',
            groupTitle: `Top goalscorers`,
            groupKey: `Top goalscorers`,
            props: {
                tournamentId: tournament.id,
                seasonId: season.id,
                sortBy: 'stats.goals'
            },
            key: `tl-${season.id}-${tournament.id}`
        },
        {
            name: 'TopListSMWidget',
            groupTitle: `Top assisters`,
            groupKey: `Top assisters`,
            props: {
                tournamentId: tournament.id,
                seasonId: season.id,
                sortBy: 'stats.assists'
            },
            key: `ta-${season.id}-${tournament.id}`
        },
        {
            name: 'TopListSMWidget',
            groupTitle: `Most cleansheets`,
            groupKey: `Most cleansheets`,
            props: {
                tournamentId: tournament.id,
                seasonId: season.id,
                sortBy: 'stats.cleansheets'
            },
            key: `tc-${season.id}-${tournament.id}`
        }
    ];

class TournamentHomeSMB extends React.Component {
    EventsList;
    componentDidMount = () => {
        const {
            dispatch,
            fetchEvents,
            params: { tournamentId, seasonId },
            season
        } = this.props;

        dispatch(
            fetchEvents({
                ttId: tournamentId,
                seasonId,
                status: 'notstarted',
                fromDate: moment()
                    .startOf('day')
                    .format('YYYY-MM-DD')
            })
        );

        if (~~seasonId !== season.id) {
            window.history.pushState('', '', `${season.id}`);
        }
    };

    componentWillReceiveProps = nextProps => {
        const {
            dispatch,
            fetchEvents,
            params: { tournamentId, seasonId }
        } = nextProps;

        if (+this.props.params.tournamentId !== +tournamentId || this.props.params.seasonId !== seasonId) {
            dispatch(
                fetchEvents({
                    ttId: tournamentId,
                    seasonId,
                    status: 'notstarted',
                    fromDate: moment()
                        .startOf('day')
                        .format('YYYY-MM-DD')
                })
            );
        }
    };

    renderCup = () => {
        const { events, tournament, season } = this.props;

        return (
            <div>
                <EventsList events={events} />
                <SMStream smWidgets={matchesList(tournament, events)} title="Matchdays" />
                <SMStream smWidgets={basicTopList(tournament, season, events)} title="Top Lists" />
            </div>
        );
    };

    renderLeague = () => {
        const { events, tournament, season, teams } = this.props;
        const matceshInRound = teams.length / 2;
        return (
            <div>
                <EventsList events={events} limit={matceshInRound} />

                <SMStream smWidgets={matchesList(tournament, events, 3)} title="Matchdays" />
                <SMStream smWidgets={generalTournamentWidget(tournament, season, true, true)} title="Standings" />
                <SMStream smWidgets={basicTopList(tournament, season, events)} title="Top Lists" />
            </div>
        );
    };

    renderWC = () => {
        const { events, tournament, season, teams } = this.props;
        const matceshInRound = teams.length / 2;

        return (
            <div>
                <EventsList events={events} limit={matceshInRound} />

                <SMStream
                    smWidgets={[
                        {
                            name: 'WorldRankingSMWidget',
                            props: {
                                tournamentId: tournament.id
                            }
                        },
                        {
                            name: 'TournamentPlayOffSMWidget',
                            props: {
                                tournamentId: tournament.id,
                                stageIds: JSON.stringify(_.filter(season.stages, s => s.isCup).map(s => s.id))
                            }
                        },
                        {
                            name: 'TournamentPlayOffSMWidget',
                            groupKey: 'last year',
                            groupTitle: 'Last Year winner',
                            props: {
                                tournamentId: 77,
                                stageIds: JSON.stringify([831483, 831480, 831482, 831481, 831479])
                            }
                        }
                    ]}
                    title="Facts"
                />

                <SMStream smWidgets={matchesList(tournament, events, 3)} title="Matchdays" />
                <SMStream smWidgets={generalTournamentWidget(tournament, season, true)} title="Standings" />
                <SMStream smWidgets={playoffWCStage(tournament, season)} title="Playoff" />
                <SMStream smWidgets={basicTopList(tournament, season, events)} title="Top Lists" />
            </div>
        );
    };

    renderCL = () => {
        const { events, tournament, season, stages, teams } = this.props;
        const matceshInRound = teams.length / 2;

        return (
            <div>
                <EventsList events={events} limit={matceshInRound} />
                <SMStream smWidgets={matchesList(tournament, events, 3)} title="Matchdays" />
                <SMStream smWidgets={generalTournamentWidget(tournament, season)} title="Standings" />
                <SMStream smWidgets={playoffCLStage(tournament, season, stages)} title="Playoff" />
                <SMStream smWidgets={basicTopList(tournament, season, events)} title="Top Lists" />
            </div>
        );
    };

    renderFriendlies = () => {
        const { events, tournament, teams } = this.props;
        const matceshInRound = teams.length / 2;

        return (
            <div>
                <EventsList events={events} limit={matceshInRound} />
                <SMStream smWidgets={matchesList(tournament, events, 3)} title="Matchdays" />
            </div>
        );
    };

    renderMixed = () => {
        const { events, tournament, season, teams } = this.props;
        const matceshInRound = teams.length / 2;

        return (
            <div>
                <EventsList events={events} limit={matceshInRound} />
                <SMStream smWidgets={matchesList(tournament, events, 3)} title="Matchdays" />
                <SMStream smWidgets={generalTournamentWidget(tournament, season, true, true)} title="Standings" />
                <SMStream smWidgets={basicTopList(tournament, season, events)} title="Top Lists" />
            </div>
        );
    };

    render() {
        const { tournament } = this.props;

        if (!tournament) return <div />;

        // special cases
        if ([77, 50].indexOf(tournament.id) !== -1) return this.renderWC();
        if ([42, 73].indexOf(tournament.id) !== -1) return this.renderCL();
        if ([114, 134].indexOf(tournament.id) !== -1) return this.renderFriendlies();

        switch (tournament.type) {
            case 'league':
                return this.renderLeague();
            case 'cup':
                return this.renderCup();
            case 'mixed':
                return this.renderMixed();
            default:
                return this.renderLeague();
        }
    }
}

export default connect(
    (state, props) => {
        const { tournamentId, seasonId } = props.params;
        const ids = _.get(
            state,
            `query.entities[${fetchEventsKey({
                ttId: tournamentId,
                seasonId,
                status: 'notstarted',
                fromDate: moment()
                    .startOf('day')
                    .format('YYYY-MM-DD')
            })}]`,
            []
        );
        const events = _.get(state, `query.entities.events`, []);

        return {
            events: ids.map(id => events[id]),
            tournament: _.get(state.smBrowser, 'tournament'),
            season: _.get(state.smBrowser, 'season', {}),
            teams: _.get(state.smBrowser, 'teams')
        };
    },
    dispatch => ({
        dispatch,
        fetchEvents
    })
)(TournamentHomeSMB);



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/TournamentHomeSMB.js
 **/